class DetailsDisclosure extends HTMLElement {
	constructor() {
		super();
		this.mainDetailsToggle = this.querySelector("details");
		if (!this.mainDetailsToggle) return;

		this.addEventListener("keyup", this.onKeyUp);
		document.addEventListener("click", this.onFocusOut.bind(this));
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		const summaryElement = openDetailsElement.querySelector("summary");
		if (!summaryElement) return;

		openDetailsElement.removeAttribute("open");
		summaryElement.focus();
	}

	onFocusOut(e) {
		if (!this.mainDetailsToggle) return;
		
		const withBoundaries = e.composedPath().includes(this.mainDetailsToggle);

		if (!withBoundaries) {
			this.mainDetailsToggle.removeAttribute("open");
		}
	}

	close() {
		if (!this.mainDetailsToggle) return;
		this.mainDetailsToggle.removeAttribute("open");
	}
}

customElements.define("details-disclosure", DetailsDisclosure);

class DetailsDisclosureFilter extends HTMLElement {
	constructor() {
		super();
		this.mainDetailsToggle = this.querySelector("details");
		if (!this.mainDetailsToggle) return;

		this.content = this.mainDetailsToggle.querySelector(
			".facets__wrapper .close_filter_element"
		);
		if (!this.content) return;

		this.addEventListener("keyup", this.onKeyUp);
		this.content.addEventListener("focusout", this.onFocusOut.bind(this));
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		const summaryElement = openDetailsElement.querySelector("summary");
		if (!summaryElement) return;

		openDetailsElement.removeAttribute("open");
		summaryElement.focus();

		const facetsWrapper = document.querySelector(".facets__wrapper");
		if (facetsWrapper) {
			facetsWrapper.classList.remove("active");
		}

		const facetsMask = document.querySelector(".facets-mask");
		if (facetsMask) {
			facetsMask.classList.remove("active");
		}

		const facetsButtonShow = document.querySelector(".facets__button-show");
		if (facetsButtonShow) {
			facetsButtonShow.classList.remove("active");
		}
	}

	onFocusOut() {
		setTimeout(() => {
			this.close();
		});
	}

	close() {
		if (!this.mainDetailsToggle) return;

		this.mainDetailsToggle.removeAttribute("open");
		const summary = this.mainDetailsToggle.querySelector("summary");
		if (summary) {
			summary.setAttribute("aria-expanded", false);
		}
	}
}

customElements.define("details-disclosure-filter", DetailsDisclosureFilter);
